export default {
  en: {
    'bundles-reduced-rates.title': 'Reduced Rates',
    'bundles-reduced-rates.duplicate-message.heading': 'Duplicate ASIN',
    'bundles-reduced-rates.duplicate-message.text':
      'Please note you have entered duplicate ASIN codes. Please amend them before continuing.',
    'bundles-reduced-rates.save.success': 'SKU/Product codes updated successfully',
    'bundles-reduced-rates.save.error': 'Failed to update SKU/Product codes. Please try again.',
    'bundles-reduced-rates.no-results-title': 'No registrations found',
    'bundles-reduced-rates.no-results-message':
      'No active registrations are associated with this entity',
  },
};
